module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/logo-red-f4ef811dfba340be00e6a267442f8306.svg";